import helper from "../../store/helpers/helper.js";

export default {
   name: 'TicketMessage',
   components: {},
   data() {
      return {
         bias: null
      }
   },
   props: {
      type: {
         type: Boolean,
         default: 'answer'
      },
      text: {
         type: String,
         default: 'Message text'
      },
      date: {
         type: String,
         default: '01-01-2021'
      },
      image_url: {

      }
   },
   methods: {
      showFull(img) {
         this.$emit('showFullImage', img)
      },
      formatTextForMessage(text) {
         let str = helper.formatTextForOutput(text);
         return str;
      }
   },
   created() {
      this.bias = Number(new Date(Date.now()).getTimezoneOffset());
   }
}
